import { Div, Select, TextInput } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class InputRow extends Div
{
    constructor(label: string, ...content: appendable[])
    {
        super("InputRow");
        this.Style(`background-color: #172436; padding: 8px; border-radius: 8px; margin: 8px;`);

        if (!Array.isArray(content))
        {
            content = [content];
        }

        const labelPlace = new Div("fixed-width").Text(label).FontSize(18)

        if (content[0] instanceof TextInput || content[0] instanceof Select)
            labelPlace.Padding(8)

        this.Append(
            labelPlace,
            new Div("flexible-width").Append(...content)
        )
    }
}
